import { Component } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { PeoplePermissionsComponent } from "../people-permissions/people-permissions.component";

@Component({
  selector: 'app-personalize',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    PeoplePermissionsComponent
],
  template: `
      <div>

      <app-people-permissions></app-people-permissions>
      </div>

  `,
  styleUrl: './personalize.component.css'
})
export class PersonalizeComponent {

}
